var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnisex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.12-340q66.34 0 113.11-46.89Q640-433.79 640-500.12q0-66.34-46.89-113.11Q546.21-660 479.88-660q-66.34 0-113.11 46.89Q320-566.21 320-499.88q0 66.34 46.89 113.11Q413.79-340 480.12-340ZM460-60v-80h-80v-40h80v-120.92q-76.46-9.39-128.23-65.77Q280-423.08 280-500q0-34.54 11.42-66.92 11.43-32.39 32.73-60.16l-59.84-59.84-56 56-27.54-27.54 56-56.23L120-831.46V-700H80v-200h200v40H148.54l116.77 116.77 56.23-56 27.54 27.54-56 56.23 60.61 60.61q27-21.53 59.39-33.34Q445.46-700 480-700t66.92 11.81q32.39 11.81 59.39 33.34L811.46-860H680v-40h200v200h-40v-131.46L634.85-626.54q21.3 27.23 33.23 59.48Q680-534.81 680-500q0 76.92-51.77 133.31-51.77 56.38-128.23 65.77V-180h80v40h-80v80h-40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisex);
export default __webpack_public_path__ + "static/media/unisex.bdb1dc9a9ce2c2154d06998c0d5951b1.svg";
export { ForwardRef as ReactComponent };